import { selectDeleteRolePopover } from "@/features/management-settings/view-models/select-delete-role.view-model";
import type { RoleListItem } from "@/models/role.model";
import type { DataTableColumn } from "@spz/ui/components/table/types";
import { formatCellValue } from "@spz/ui/lib/utils";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useUpsertRoleDialog } from "../dialogs/use-upsert-role-dialog";

export const useRolesColumns = () => {
  const { t } = useTranslation();
  const deleteRolePopover = selectDeleteRolePopover();
  const roleDialog = useUpsertRoleDialog();

  return useMemo<DataTableColumn<RoleListItem>[]>(
    () => [
      {
        accessorKey: "name",
        header: t("name"),
        type: "text",
        cellProps: (row) => ({
          value: row.name,
        }),
      },
      {
        accessorKey: "description",
        header: t("description"),
        type: "text",
        cellProps: (row) => formatCellValue(row.description, "text"),
      },
      {
        accessorKey: "permissionsCount",
        header: t("number_of_permissions"),
        type: "numeric",
        cellProps: (row) => ({
          value: row.permissionsCount,
        }),
      },
      {
        accessorKey: "actions",
        header: "",
        type: "button",
        size: 30,
        enableSorting: false,
        cellProps: (row) => ({
          buttons: [
            {
              label: t("edit"),
              type: "icon",
              icon: "edit",
              variant: "ghost",
              onClick: () => {
                roleDialog.open({ roleId: row.id });
              },
            },
            {
              label: t("delete"),
              type: "icon",
              icon: "trash-2",
              variant: "ghost",
              onClick: (e) => {
                deleteRolePopover.open({
                  roleId: row.id,
                  anchorElement: e.currentTarget,
                  updatedAt: row.updatedAt ?? undefined,
                });
              },
            },
          ],
        }),
      },
    ],
    [t, deleteRolePopover, roleDialog],
  );
};
